<script setup lang="ts">
    import { HolidayPayObligationEntry } from '@/types';
    import { HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'reka-ui';
    import DataTableCurrency from '@/components/datatable/DataTableCurrency.vue';
    import { formatCurrency } from '@/utils/helpers';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    defineProps<{
        value: number;
        holidayPayObligationEntry: HolidayPayObligationEntry;
    }>();
</script>

<template>
    <DataTableCurrency
        v-if="!holidayPayObligationEntry.calculator"
        :value="value"
        :return-zero="true"
    />
    <HoverCardRoot
        v-else
        :close-delay="0"
        :open-delay="200"
    >
        <HoverCardTrigger>
            <DataTableCurrency
                :value="value"
                :return-zero="true"
            />
        </HoverCardTrigger>
        <HoverCardPortal>
            <HoverCardContent
                class="animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 flex flex-col gap-1 rounded-xl border bg-white p-4 shadow-sm data-[state=open]:transition-all"
                :side-offset="5"
            >
                <span class="text-xs">
                    {{
                        formatCurrency(holidayPayObligationEntry.calculator.obligation.basic_salary)
                    }}
                    {{ t('holiday-pay-obligations.entries.tooltip.obligation.basic_salary') }}
                </span>
                <span class="text-xs">
                    /
                    {{ formatCurrency(holidayPayObligationEntry.calculator.obligation.work_days) }}
                    {{ t('holiday-pay-obligations.entries.tooltip.obligation.work_days') }}
                </span>
                <span class="text-xs">
                    *
                    {{
                        formatCurrency(
                            Number(
                                holidayPayObligationEntry.calculator.obligation.days_outstanding,
                            ),
                        )
                    }}
                    {{ t('holiday-pay-obligations.entries.tooltip.obligation.days_outstanding') }}
                </span>
            </HoverCardContent>
        </HoverCardPortal>
    </HoverCardRoot>
</template>
